<template>
	<v-modal class="v-modal--welcome-form v-modal--expanded">
		<template v-slot:header>
			<h1 class="alpha">Confirm Personal Details</h1>
		</template>
		<form v-if="form.initialized" @submit.prevent>
			<v-tabs
				ref="tabs"
				:tabless="false"
				:update-hash="false"
				class="tabs--bullets">
				<v-tab
					v-for="(client, clientId) in clients"
					id="client"
					:key="clientId"
					:id-index="clientId"
					:label="clientLabel(client)"
					class="section">
					<fieldset v-if="form.data.clients[clientId]">
						<div>
							<div>
								<legend>
									<span class="alpha highlight-text" v-html="clientLabel(client)"/>
								</legend>
							</div>
							<div>
								<div class="form-input input-group">
									<div
										v-if="form.errors.get('title')" class="error-block">
										<p v-html="form.errors.get('title')"></p>
									</div>
									<!--									<label><span>Title </span>-->
									<!--										<select v-model="form.data.clients[clientId].title">-->
									<!--											<option disabled selected value="">—</option>-->
									<!--											<option value="Mr">Mr</option>-->
									<!--											<option value="Mrs">Mrs</option>-->
									<!--											<option value="Ms">Ms</option>-->
									<!--											<option value="Miss">Miss</option>-->
									<!--										</select>-->
									<!--									</label>-->
									<label><span>First name </span>
										<div
											v-if="form.errors.get('name_first')" class="error-block">
											<p v-html="form.errors.get('name_first')"></p>
										</div>
										<input
											v-model="form.data.clients[clientId].name_first"
											type="text">
									</label>
									<label><span>Last name </span>
										<div
											v-if="form.errors.get('name_last')" class="error-block">
											<p v-html="form.errors.get('name_last')"></p>
										</div>
										<input
											v-model="form.data.clients[clientId].name_last"
											type="text">
									</label>
								</div>
								<label><span>Email </span>
									<div
										v-if="form.errors.get('email')" class="error-block">
										<p v-html="form.errors.get('email')"></p>
									</div>
									<input v-model="form.data.clients[clientId].email" type="text">
								</label>
								<label><span>Phone </span>
									<div
										v-if="form.errors.get('phone')" class="error-block">
										<p v-html="form.errors.get('phone')"></p>
									</div>
									<input v-model="form.data.clients[clientId].phone" type="text">
								</label>
								<label><span>Date of birth</span>
									<div
										v-if="form.errors.get('dob')" class="error-block">
										<p v-html="form.errors.get('dob')"></p>
									</div>
									<v-dobpicker
										v-model="form.data.clients[clientId].dob"
										date-display-format="DD/MM/YYYY"/>
									<div class="help-block">
										<p>Please enter your date of birth in the following format dd/mm/yyyy.</p>
									</div>
								</label>
								<label
									class="checkbox alert alert--warning"><span>Please confirm that these details are accurate </span>
									<input
										v-model="form.data.clients[clientId].details_confirmed"
										type="checkbox">
									<div v-if="client.idCheck" class="help-block">
										<p>Before confirming your details, please ensure they are correct as any incorrect information may result in an additional ID check having to be carried out for which you will be charged an additional fee.</p>
									</div>
								</label>
							</div>
						</div>
					</fieldset>
				</v-tab>
				<v-tab
					id="correspondence-address"
					class="section"
					label="Correspondence Address">
					<fieldset>
						<div>
							<div>
								<legend><span class="alpha highlight-text">Correspondence Address</span></legend>
							</div>
							<div>
								<template v-if="!clientGroup.correspondenceAddress && saleProperties.length">
									<label class="mt-2"><span>Select a correspondance address </span>
										<select v-model="saleProperty" @change="determineAddress()">
											<option disabled value="">—</option>
											<option
												v-for="(saleProperty, propertyIndex) in saleProperties"
												:key="propertyIndex"
												:value="saleProperty.id"
												v-html="saleProperty.address.asLine"/>
											<option :value="null">Other</option>
										</select>
									</label>
								</template>
								<AddressLookup
									v-if="clientGroup.correspondenceAddress || !saleProperties.length || saleProperty === null"
									ref="correspondenceAddressLookup"
									v-model="form.data.address"
									:errors="form.errors"
									:prefill="clientGroup.correspondenceAddress"
									fieldId="address"
									v-on:addressCompleteStatus="status => addressComplete = status"/>
								<label
									v-if="saleProperty || addressComplete"
									class="checkbox alert alert--warning"><span>Please confirm this is the correct correspondence address </span>
									<input
										v-model="form.data.address.details_confirmed"
										type="checkbox">
								</label>
							</div>
						</div>
					</fieldset>
				</v-tab>
			</v-tabs>
		</form>
		<template v-slot:footer>
			<ul v-if="refs.tabs" class="actions actions--right">
				<li>
					<button
						class="button button--text"
						@click.prevent="$vmodal.close()">Close
					</button>
				</li>
				<li>
					<process-button
						:processing="form.processing"
						:text="!refs.tabs.next ? 'Save' : 'Save And Continue'"
						class="button button--primary"
						@click.prevent="save()"/>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>
import AddressLookup from "../../../components/forms/fields/AddressLookup";
import essentialTasks from "../mixins/essentialTasks";

export default {
	components: {
		AddressLookup,
	},

	mixins: [
		essentialTasks,
	],

	data() {
		return {
			form: this.newForm({
				clients: [{
					// title: "",
					name_first: "",
					name_last: "",
					email: "",
					dob: "",
					phone: "",
					details_confirmed: false,
				}],
				address: {
					address_identifier: "",
					address_locality: "",
					address_province: "",
					address_postcode: "",
					details_confirmed: false,
				},
			}),
			saleProperty: "",
			addressComplete: false,
		};
	},

	computed: {
		clients() {
			let clientIds = this.$store.getters.nextTask().data.clients;
			return _.pickBy(this.clientGroup.clients, (client) => {
				return clientIds.indexOf(client.id) > -1;
			});
		},
		saleProperties() {
			return _.filter(this.$authed().clientGroup.interactiveInstructions, instruction => {
				return instruction.service_variant === "sale";
			});
		},
	},

	methods: {
		clientLabel(client) {
			let clientName = this.form.getData("clients", client.id).name_first;
			let clientId = _.keys(this.clientGroup.clients).length > 1
				? this.$present("ordinal", _.indexOf(_.keys(this.form.getData("clients")), client.id) + 1)
				: null;
			return !clientName ? [clientId, "Client Details"].join(" ") : clientName + "'s Details";
		},
		determineAddress() {
			if (!this.saleProperty) {
				this.refs.correspondenceAddressLookup?.reset();
				return;
			}

			let saleProperty = _.find(this.saleProperties, instruction => {
				return instruction.id === this.saleProperty;
			});
			this.form.set("address", saleProperty.address);
		},
		save() {
			this.form.patch(this.route("welcome")).then(response => {
				this.$store.commit("authStore/SET_AUTHED", response.data);

				if (!this.refs.tabs.next) {
					this.shakeTask();
					this.$vmodal.close(() => {
						this.showNextTaskModal("confirmPersonalDetails");
					});
				}

				this.refs.tabs.goToNext();
			});
		},
	},

	created() {
		this.form.prepare((form) => {
			form.prefill({
				clients: this.clients,
			});
		});
	},
};
</script>
